import { EOfferScopeStatus } from '../../enum'

/*type IOfferScopeStatusLangKey =
	| EOfferScopeStatus.none
	| EOfferScopeStatus.active
	| EOfferScopeStatus.paused
	| EOfferScopeStatus.closed*/

// Create a union type of all possible values from the enum
type IOfferScopeStatusLangKey = `${EOfferScopeStatus}`

export type IOfferScopeStatusLang = {
	offer_scope_status: Record<IOfferScopeStatusLangKey, string>
}

const langEntries = Object.entries(EOfferScopeStatus).map(
	([key, value]) => [value, `offer_scope_status.${value}`]
)

const langObj: Record<IOfferScopeStatusLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SCOPE_STATUS_LANG_KEY: IOfferScopeStatusLang = {
	offer_scope_status: langObj
}
